<div class="tree-node" [style.--level]="node.level" [style.--top]="node.topSticky + 'px'"
    [style.--indent]="(node.level * 24) + 'px'">

    <div class="tree-node-header">
        <div class="toggle" *ngIf="haveChildren()" (click)="toggle(); emitNode(); $event.stopPropagation()">
            <bzg-icon [nameIcon]="node.isExpanded ? 'minus' : 'plus'" [size]="12"></bzg-icon>
        </div>

        <div class="node-icon-wrapper" [ngClass]="{ 'with-connector': haveChildren() }">
            <bzg-icon [nameIcon]="getNodeTypeIcon(node)" [size]="16" class="node-icon" (click)="handleNodeClick()"></bzg-icon>
        </div>

        <span class="node-name" (click)="handleNodeClick()">{{ displayNodeName }}</span>
    </div>

    <div class="tree-node-children" *ngIf="node.isExpanded && haveChildren()">
        <app-processes-tree-view-node 
            *ngFor="let child of node.nodes; let i = index" 
            [node]="child"
            [isLast]="i === (node.nodes?.length || 0) - 1" 
            [value]="node" 
            (selectedNode)="selectedNode.emit($event)" 
            (nodeToggled)="nodeToggled.emit($event)">
        </app-processes-tree-view-node>
    </div>
</div>